import styled, { css } from 'styled-components';

export const StyledLink = styled.div`
  text-decoration: none;
  cursor: pointer;
`;

export const ArticleCard = styled.div`
  break-inside: avoid;
  page-break-inside: avoid;
  display: inline-block;
  width: 100%;
`;

export const ImageWrapper = styled.div<{
  $deskHeight?: number;
  $height?: number;
}>`
  position: relative;
  width: 100%;
  height: ${({ $height }) => ($height ? `${$height}px` : 'auto')};
  min-height: 200px;
  overflow: hidden;
  ${({ $deskHeight, theme }) => css`
    ${theme.media.md.up} {
      ${$deskHeight &&
      css`
        height: ${$deskHeight}px;
      `}
    }
  `};
`;

export const ArticleTag = styled.span`
  display: inline-block;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.secondaryGrey};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-size: ${({ theme }) => theme.fontSizes.p3};
  margin-top: ${({ theme }) => theme.spacing(2.5)};
`;

export const InlineList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(1)};
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const InlineListItem = styled.li`
  display: inline-block;
`;

export const ArticleTitle = styled.h2`
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.fontFamilies.italianPlate};
  font-size: ${({ theme }) => theme.fontSizes.h5};
  margin-top: ${({ theme }) => theme.spacing(1.5)};
`;

// Safari sometimes ignores the `-webkit-line-clamp` and `max-height` of the text content and renders it with height of full content
export const ArticlePreviewTextWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing(2)};
  max-height: calc(${({ theme }) => theme.lineHeights.p2} * 3); /* 3 lines */
  overflow: hidden;
`;

export const ArticlePreviewText = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.p2};
  line-height: ${({ theme }) => theme.lineHeights.p2};

  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
`;

export const ButtonWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.spacing(3)};
  `};
`;
